export class EjecutivaReport {
  fechaInicio: Date;
  fechaFin: Date;
  reportId: string;
}
